import React from 'react';
import styles from './FourNotFour.module.css';

const FourNotFour = () => (
  <div>
    <div className={styles.imageWrapper}>
      <div className={styles.fourNotFourText}>404</div>
      <div className={styles.notFoundText}>Not Found</div>
    </div>
    <div className={styles.errorTitle}>Oops, looks like something went wrong!</div>
  </div>
);;

export default FourNotFour;
